import { useState, useCallback } from "react";
import "@/App.css";
import HeroLanding from "./components/HeroLanding";
import OktoberFest from "./components/OktoberFest";
import MusicPlayer from "./components/MusicPlayer";
import ParticleCanvas from "./components/ParticleCanvas";
import WelcomeQuote from "./components/WelcomeQuote";
import RSVPAdmin from "./components/RSVPAdmin";

function App() {
  const isAdminPage = window.location.pathname === '/rsvp-admin';

  const [phase, setPhase] = useState(() => {
    return sessionStorage.getItem('mc_phase') || 'landing';
  });

  const handleEnter = useCallback(() => {
    setPhase('quote');
  }, []);

  const handleQuoteComplete = useCallback(() => {
    sessionStorage.setItem('mc_phase', 'camp');
    setPhase('camp');
  }, []);

  if (isAdminPage) {
    return <RSVPAdmin />;
  }

  return (
    <div className="App min-h-screen bg-[var(--mc-bg)]">
      <ParticleCanvas />
      <MusicPlayer currentTrack={phase === 'landing' ? 'landing' : 'camp'} paused={false} />

      {phase === 'landing' && (
        <HeroLanding onEnter={handleEnter} />
      )}

      {phase === 'quote' && (
        <WelcomeQuote onComplete={handleQuoteComplete} />
      )}

      {phase === 'camp' && (
        <OktoberFest />
      )}
    </div>
  );
}

export default App;
